/* eslint-env browser */
import 'babel-preset-es2017/polyfill';
import 'isomorphic-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import {IndexRoute, Route, Router, RouterContext, useRouterHistory, browserHistory} from 'react-router';
import {Provider} from 'react-redux';
import HomeContainer from './HomeContainer';
import QuestionContainer from './QuestionContainer';
import QuestionForm from './QuestionForm';
import AppContainer from './AppContainer';
import SearchContainer from './SearchContainer';

import readCookie from '../lib/cookies';
import {configureStore, getRootSagas, createStoreAndRunSagas} from '../lib/app';
import {showQuestion, showTag} from '../modules/Navigation';

const isServerSide = !global.document;
if (!isServerSide) {
  require('../css/app.scss'); // eslint-disable-line global-require
}

function getRoutes() {
  return (
    <Route path="/" component={AppContainer}>
      <IndexRoute name="home" component={HomeContainer} />
      <Route name="tag" component={HomeContainer} path="tag/:tag" />
      <Route name="new-question" component={QuestionForm} path="create" />
      <Route name="edit-question" component={QuestionForm} path="edit/:questionId" />
      <Route name="search" component={SearchContainer} path="search" />
      <Route name="question" component={QuestionContainer} path="*" />
    </Route>
  );
}

function getServerContext(store, props) {
  return (
    <Provider store={store}>
      <RouterContext {...props} />
    </Provider>
  );
}

function getClientContainer(store, history) {
  const routes = getRoutes();

  const state = store.getState();
  const widget = state.environment.widget;

  const scrollToTop = () => {
    if (!widget) {
      window.scrollTo(0, 0);
    }
  };

  return (
    <Provider store={store}>
      <Router routes={routes} onUpdate={scrollToTop} history={history} />
    </Provider>
  );
}

function initializeClient() {
  const userId = readCookie('TESCookieUser');
  const initialState = window.__INITIAL_STATE__; // eslint-disable-line no-underscore-dangle
  const history = useRouterHistory(() => browserHistory)({
    basename: initialState.environment.widgetConfig.baseUrl,
  });
  const store = createStoreAndRunSagas({initialState, fetch, userId, history});
  ReactDOM.render(getClientContainer(store, history),
    global.document.getElementById('app-tes-answers__home')
  );
  global.TES.events.on('contextualLinkClicked', (eventName, url) => store.dispatch(showQuestion(url)));
  global.TES.events.on('contextualTagClicked', (eventName, tag, contextType) => store.dispatch(showTag(false, tag, contextType)));
}

export default {configureStore, getRootSagas, getRoutes, getServerContext};

if (global.document) {
  global.document.addEventListener('DOMContentLoaded', initializeClient);
}
